module.exports = __webpack_public_path__ + "img/备料1.eb81c89e.svg";